






























































































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import {mapGetters} from 'vuex';
import CSelect from '@/components/base/select/CSelect.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CVolumeField from '@/components/base/volumeField/CVolumeField.vue';
import CTable from '@/components/base/table/CTable.vue';

@Component({
    components: {CTable, CVolumeField, CCheckbox, CDatepicker, CNumberField, CTextField, CEditDialog, CSelect},
    computed: {
        ...mapGetters(['hideableProperties']),
    },
})
export default class PlanPlywoodOrderEditDialog extends Mixins(EditDialogMixin) {
    public hideableProperties!: any[];

    get codeRules() {
        return [
            (v: any) =>
                /(^[А-ЯЁа-яёЁA-Za-z0-9/(/)""/%№+-]+[А-ЯЁа-яёЁA-Za-z0-9/(/)""\s/%№+-]*$|^$)/.test(v) ||
                this.$t('Common.Messages.AlphaNumericExpression'),
        ];
    }

    get tableHeaders() {
        return [
            {
                value: 'Number',
                text: this.$t('Catalogues.ShiftTml.Shift'),
            },
            {
                value: 'Volume.Value',
                text: this.$t('Common.Volume'),
            },
            {
                value: 'Volume.IdMeasureUnit',
                text: this.$t('Common.VolumeUnit'),
                sort: this.getDescriptionsContainer().getSortFn(this.addDescriptionPostfix(this.$api.measureUnit)),
            },
        ];
    }
}
